import classNames from "classnames";
import classes from "./FCCBanner.module.less";
import { Button, Stack, Typography } from "~/common/mui";
import { ACTIVE_QUOTE_PAGE, FREE_CAPACITY_COCKPIT, QUOTE_CONFIRMATION_PAGE } from "~/utils/url/staticUrls";
import { Trans, useTranslation } from "react-i18next";
import { FccAction, trackFccAction } from "~/features/freeCapacityPush/api/trackFccAction";

export const FCCBanner = () => {
  const { t } = useTranslation();
  return (
    <div className={classNames(classes.root)}>
      <Stack gap={3} direction={"row"}>
        <Typography color={"inherit"} variant={"titleMedium"}>
          <Trans i18nKey={"page.fcc.banner.label"} />
        </Typography>
        <Button size={"medium"} href={FREE_CAPACITY_COCKPIT} onClick={() => trackFccAction(FccAction.BannerClick)}>
          {t("page.fcc.banner.button")}
        </Button>
      </Stack>
    </div>
  );
};

const DISABLED_PAGES = [ACTIVE_QUOTE_PAGE, QUOTE_CONFIRMATION_PAGE, FREE_CAPACITY_COCKPIT];

export const isFCCBannerVisible = () => {
  if (!window.SCHA.config.fccShowBannerEnabled) {
    return false;
  }

  const pathname = window.location.pathname;
  if (DISABLED_PAGES.some((page) => pathname.endsWith(page))) {
    return false;
  }
  return true;
};
